"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppointmentIdContainer = exports.StyledBannerTitle = exports.BannerContainer = exports.EarlyCheckinButton = exports.PrintAndCalendarButtons = exports.StyledPrintButtonContainer = exports.StyledButtonContainer = exports.StyledProviderContainerDesktop = exports.StyledProviderContainerMobile = exports.StyledContentContainer = exports.StyledContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const breakpoints_1 = require("../../../lib/constants/breakpoints");
exports.StyledContainer = styled_1.default.div `
  display: block;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  @media screen and (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    padding-bottom: 88px;
  }

  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    display: flex;
    justify-content: space-between;
  }
`;
exports.StyledContentContainer = styled_1.default.div `
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    flex-grow: 1;
    border-bottom: 0px;
    padding: 0px;
  }
`;
exports.StyledProviderContainerMobile = (0, styled_1.default)('div') `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};

  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    display: none;
  }
`;
exports.StyledProviderContainerDesktop = (0, styled_1.default)('div') `
  display: none;

  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    display: block;
    max-width: ${breakpoints_1.SIDEBAR_WIDTH};
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }
`;
exports.StyledButtonContainer = styled_1.default.div `
  // hide this for print
  @media print {
    display: none;
  }

  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    display: flex;
    justify-content: ${({ hasPrevisitUrl }) => hasPrevisitUrl ? 'space-between' : 'flex-end'};
  }
`;
exports.StyledPrintButtonContainer = styled_1.default.div `
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.PrintAndCalendarButtons = styled_1.default.div `
  // Adding this to handle print button in drawer view
  // when rendering through a portal
  @media print {
    display: none;
    @page {
      margin: 0;
    }
  }

  display: flex;
  justify-content: space-between;
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};

  > div {
    flex-grow: 1;
  }

  > div > button {
    width: 100%;
  }

  /* Desktop styles */
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }

  /* Mobile styles: Fixed at the bottom */
  @media screen and (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    // For drawer view, we want to fix buttons to the bottom of the drawer
    ${({ isDrawerView }) => isDrawerView && 'position: absolute;'};
    // For mobile and not in drawer, we want to fix buttons to the bottom of the screen
    ${({ isDrawerView, aboveMd }) => !aboveMd && !isDrawerView && 'position: fixed;'};
    // For web view, we don't want to fix the buttons to the bottom of the screen
    ${({ aboveMd }) => aboveMd && 'position: static;'};
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    align-items: center;
    padding: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    z-index: 1000;
    div {
      flex: 1;
    }
    button {
      width: 100%;
    }
  }
`;
exports.EarlyCheckinButton = styled_1.default.div `
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} ${(0, ui_theme_1.fromTheme)('spacing_large')}
    ${(0, ui_theme_1.fromTheme)('spacing_large')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  > button {
    width: 100%;
  }
`;
exports.BannerContainer = styled_1.default.div `
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.StyledBannerTitle = styled_1.default.div `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};

  @media screen and (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    display: none;
  }
`;
exports.StyledAppointmentIdContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
//# sourceMappingURL=styles.js.map